/**
 *  Generates the additional parameters to pass
 *  to the ui host to boot documents with templates with
 *  the ui hose
 * @param contentLaunchParams
 */
export function getAdditionalWacParamsFromLaunchParams(contentLaunchParams) {
    var _a;
    var newContentParams = (_a = contentLaunchParams.newContentParams) !== null && _a !== void 0 ? _a : {};
    var templateItemId = newContentParams.templateItemId, templateDriveId = newContentParams.templateDriveId;
    if (templateDriveId && templateItemId) {
        return { templateDriveId: templateDriveId, templateItemId: templateItemId };
    }
    else if (templateItemId) {
        return {
            wdTpl: templateItemId,
        };
    }
    return undefined;
}
//# sourceMappingURL=getAdditionalParamsFromLaunchParams.js.map